import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { matchPath, Outlet, useLocation } from "react-router-dom";

import { Loader } from "@/components/atoms";
import { Footer, Header } from "@/components/units";
import { LIVE_TRANSACTIONS_PATTERN, PATHS } from "@/config/path";
import { cn } from "@/lib/utils";
import { rootStore } from "@/store/RootStore";
import { useScrollToTop } from "@/utils/hooks/useScrollToTop";

const Layout = observer(() => {
  useScrollToTop();
  const { pathname } = useLocation();
  const { isLoggingOut } = rootStore.authStore;
  const stage =
    rootStore.authStore.isOnboarding || rootStore.authStore.isUnauthenticated;

  const isLoginPage =
    Boolean(matchPath(pathname, PATHS.ADMIN.LOGIN)) ||
    Boolean(matchPath(pathname, PATHS.RESTAURANT.LOGIN));

  useEffect(() => {
    if (isLoginPage && isLoggingOut) {
      rootStore.authStore.finishLogout();
    }
  }, [isLoginPage, isLoggingOut]);

  const pd =
    matchPath(pathname, PATHS.RESTAURANT.BRAND.ROOT) ||
    matchPath(pathname, PATHS.RESTAURANT.GROUP.ROOT) ||
    stage;

  const isNotLiveTransactions = !matchPath(
    { path: LIVE_TRANSACTIONS_PATTERN, end: true },
    pathname
  );

  if (isLoggingOut) {
    return <Loader fullscreen />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      {isNotLiveTransactions && <Header />}
      <main
        className={cn(
          "flex flex-1 bg-gray-50 text-gray-950",
          pd ? "py-[32px]" : "pt-18 md:pt-6 pb-[74px]",
          "px-[16px]",
          stage ? "justify-center items-center" : "justify-start items-start",
          !isNotLiveTransactions && "p-0! items-start"
        )}
      >
        <Outlet />
      </main>
      {isNotLiveTransactions && <Footer />}
    </div>
  );
});

export default Layout;
